import { atom } from 'recoil';

const setlistPeerIdState = atom<string>({
  key: 'setlistPeerIdState',
  default: '',
});

export default setlistPeerIdState;
